module.exports = __webpack_public_path__ + "static/media/defWithTimesLTR.29a452de.docx";